// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "ModalOverlay-module--arrow-up-and-down--fbbe6";
export var embedded = "ModalOverlay-module--embedded--52019";
export var modalContainer = "ModalOverlay-module--modalContainer--230f7";
export var modalDecenterSpace = "ModalOverlay-module--modalDecenterSpace--bd1d6";
export var modalWrapper = "ModalOverlay-module--modalWrapper--9b638";
export var overlay = "ModalOverlay-module--overlay--18629";
export var visible = "ModalOverlay-module--visible--09a8a";